export default "__VITE_ASSET__9e02395a__"